var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8V16H8H16V8V0H8H0V8ZM1.19431 8V14.8057H8H14.8057V8V1.19431H8H1.19431V8ZM9.03291 7.37748C7.92082 8.76773 7.00478 9.90751 6.99727 9.91031C6.98974 9.91312 6.51064 9.51005 5.93257 9.01462C5.35448 8.51917 4.87634 8.11378 4.87003 8.11376C4.85556 8.11374 4.08921 9.00599 4.0979 9.01276C4.1014 9.01551 4.78954 9.60466 5.62709 10.322C7.10874 11.591 7.15084 11.6253 7.18398 11.5904C7.20271 11.5707 8.27812 10.228 9.57376 8.60664C10.8694 6.98531 11.9418 5.64457 11.9568 5.6272C11.9814 5.59865 11.9427 5.56267 11.5512 5.24993C11.3132 5.05979 11.1042 4.89196 11.0867 4.87697C11.0578 4.85223 10.8696 5.0814 9.03291 7.37748Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon--check.bea095c0a099c89eea35c9a67e9818bc.svg";
export { ForwardRef as ReactComponent };